module.exports = __webpack_public_path__ + "img/c_v6.36d1b7f.png";